import { AfterViewInit, Component, Injector, NgZone, ViewChild } from '@angular/core';
import { AccountViewModel } from '../../viewModels/account-view-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../../../models/base/base-component';
import { UpdateUserInfoRequest } from '../../../../models/account/requests/update-user-info-request';
import { ConfirmCodeRequest } from '../../../../models/account/requests/confirm-code-request';
import { ComponentCanDeactivate } from '../../../../models/protocols/component-can-deactivate';
import { ActivatedRoute } from '@angular/router';
import { ReactiveFormTextComponent } from '@mobilefirstdev/reactive-form';
import { exists } from '../../../../functions/exists';
import { ModalChangePassword } from '../../../../modals/modal-change-password';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false
})
export class AccountComponent extends BaseComponent implements AfterViewInit, ComponentCanDeactivate {
  constructor(
    public viewModel: AccountViewModel,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
    private ngbModal: NgbModal,
    private injector: Injector
  ) {
    super();
  }

  @ViewChild('confirmationCodeInput') confirmationCodeInput: ReactiveFormTextComponent;
  public companyRole$ = window.types.companyRoles$;
  public code: string;
  private getActivationCodeFromParams = this.activatedRoute.queryParams.subscribeWhileAlive({
    owner: this,
    next: params => {
      if (exists(params?.Code)) {
        this.viewModel.connectToEmailVerificationCode(params.Code);
      }
    }
  });

  override setupViews(): void {}

  override ngAfterViewInit() {
    super.ngAfterViewInit(); // This will call setupBindings()
  }

  override setupBindings(): void {}

  validateConfirmationCode() {
    this.viewModel.confirmationCodeValid$.next(this.confirmationCodeInput.getSelfAsFormItem().valid);
  }

  accountInfoFormSubmitted(hydratedFormObject: UpdateUserInfoRequest): void {
    this.viewModel?.accountInformationSubmitted(hydratedFormObject);
  }

  emailConfirmationSubmit(hydratedFormObject: ConfirmCodeRequest): void {
    this.viewModel?.emailConfirmationSubmitted(hydratedFormObject);
  }

  openChangePasswordModal(): void {
    ModalChangePassword.open(this.ngZone, this.ngbModal, this.injector);
  }

  resendCode(): void {
    this.viewModel.resendCode();
  }

  canDeactivate(): boolean | Promise<any> {
    return this.viewModel.canDeactivate();
  }
}
